import { Components, Theme } from "@mui/material";

export const MuiCard: Components<Omit<Theme, "MuiCard">>["MuiCard"] = {
  variants: [
    {
      props: { color: "grey" },
      style: ({ theme: { palette } }) => ({
        background: palette.grey[100],
        borderColor: palette.grey[100],
      }),
    },
  ],
  defaultProps: {
    variant: "outlined",
  },
  styleOverrides: {
    root: {
      overflow: "visible",
    },
  },
};
